import Chip from '@mui/material/Chip'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import I18n from 'i18n-js'
import PropTypes from 'prop-types'
import { memo } from 'react'
import { Link } from 'react-router-dom'

import ChildSpacer from '../../../lib/ChildSpacer'

const campaignTypes = [
  {
    label: I18n.t('reporting.organicCampaigns'),
    value: 'organic',
  },
  {
    label: I18n.t('reporting.accelerateCampaigns'),
    value: 'paid',
  },
]

const ReportingTabs = ({ value, params }) => {
  return (
    <Tabs scrollButtons value={value} allowScrollButtonsMobile>
      {campaignTypes.map((campaignType) => {
        return (
          <Tab
            component={Link}
            to={`/retailer/reporting/${params.retailerAccountSlug}/${params.brandSlug}/${campaignType.value}`}
            key={campaignType.label}
            label={renderTabLabel(campaignType.label, campaignType.count)}
            value={campaignType.value}
          />
        )
      })}
    </Tabs>
  )
}

function renderTabLabel(channel, count) {
  if (!count) {
    return channel
  }

  return (
    <span>
      <ChildSpacer size={1}>
        {channel} <Chip label={count} size="small" />
      </ChildSpacer>
    </span>
  )
}

ReportingTabs.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default memo(ReportingTabs)
